import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class OrganisationServiceProvider extends ModelBase {

    public organisationServiceProviderId: number = 0;

    @Rules.Required()
    public organisationId: number = 0;

    @Rules.Required()
    public staticServiceProviderId: number = 0;

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}
